import { createPageReader } from '../createPageReader.jsx';
export default createPageReader('EDUCATION', 'courseDetail');
